import { Tooltip, useTheme } from "@mui/material"
import { Info } from "react-feather"

export const FamilyInfoTooltip = ({ tooltip }: { tooltip?: string | null }) => {
  const {
    typography,
    palette: { common },
  } = useTheme()

  if (!tooltip) return null

  return (
    <Tooltip title={tooltip}>
      <Info color={common.cloudGray} size={typography.pxToRem(16)} />
    </Tooltip>
  )
}
